import React from 'react';
import { color, Stack, Text } from '@starrez/starryui9';
import { ICellRenderer } from '../types';
import styled from 'styled-components';

export const EmailColumn = ({ value }: ICellRenderer<string>) => {
    return (
        <Stack height="100%">
            <StyledA href={`mailto:${value}`}>
                <Text variant="normal.regular">{value}</Text>
            </StyledA>
        </Stack>
    );
};

const StyledA = styled.a`
    cursor: pointer !important;
    color: ${color.Blue.B60};

    > * {
        cursor: pointer !important;
    }
`;
